import { jsxs, jsx } from 'react/jsx-runtime';
import { useSize } from '@flex-design-system/fx-utils/hooks';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { forwardRef } from 'react';
import { slideFrom } from '../../../../animations.mjs';
import Title from '../../../title/Title.mjs';
import { useModalContext } from '../../context.mjs';
import { StyledToolbar } from '../../styled.mjs';
import { toolbar, scrolledToolbar, toolbarWidth } from './toolbar.vanilla.mjs';

const DEFAULT_TRIGGER_TRANSITION_Y = 28;
const ModalToolbar = forwardRef(
  (props, ref) => {
    const {
      title,
      unscrolledTitle,
      children,
      leftSlot,
      className: classNameFromProps,
      style: styleFromProps,
      ...toolbarProps
    } = props;
    const {
      scrollPos,
      title: modalTitle,
      onToolbarChange,
      contentElement
    } = useModalContext("ModalToolbar");
    const mainContentSize = useSize(contentElement);
    const composedRef = useComposedRefs(ref, onToolbarChange);
    const titleAreaOffset = modalTitle?.offsetHeight ?? DEFAULT_TRIGGER_TRANSITION_Y;
    const renderToolbarTitle = scrollPos > titleAreaOffset;
    const className = classNames(
      toolbar,
      renderToolbarTitle && scrolledToolbar,
      classNameFromProps
    );
    const style = Object.assign(
      {},
      assignInlineVars({
        [toolbarWidth]: mainContentSize?.width ? `${mainContentSize.width}px` : null
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsxs(
      StyledToolbar,
      {
        className,
        style,
        ref: composedRef,
        ...toolbarProps,
        children: [
          leftSlot,
          /* @__PURE__ */ jsx(AnimatePresence, { exitBeforeEnter: true, children: renderToolbarTitle ? /* @__PURE__ */ jsx(motion.div, { ...slideFrom("bottom", 2), children: title }, "scrolled") : unscrolledTitle ? /* @__PURE__ */ jsx(motion.div, { ...slideFrom("top", 2), children: unscrolledTitle }, "unscrolled") : null }),
          children
        ]
      }
    );
  }
);
const ModalToolbarTitle = (props) => {
  const { size = "xsmall", ...titleProps } = props;
  return /* @__PURE__ */ jsx(Title, { size, ...titleProps });
};

export { ModalToolbar, ModalToolbarTitle };
//# sourceMappingURL=Toolbar.mjs.map
